import $ from 'jquery';

const $root = $('.c-calculator')
const $inputs = $root.find('select, input')
const state = {}
const $infoTextBlock = $('.js-calculator-total-replace')
const infoText = $infoTextBlock.text()

let earningsChanged = false;

function updateIconTexts(key, cost, count) {
    const $target = $(`[data-result-item=${key}]`)
    const $count = $target.find('.js-count')

    $target.find('.js-cost').html(`${cost} &euro;`)

    if ($count) {
        $count.text(`x ${count}`)
    }
}

function handleDataCost(element) {
    const key = $(element).attr('data-result-target')
    const elementValue = getElementValue(element)
    const cost = JSON.parse($(element).attr('data-cost'));

    let count = elementValue
    let finalCost = 0;

    if (Array.isArray(cost)) {
        for (let i = 0; i < elementValue; i ++) {
            if (cost[i]) {
                finalCost += cost[i]
            }
        }
    } else if (element.type === "radio") {
        finalCost = elementValue || 0
        count = false
    } else {
        finalCost = parseInt(elementValue) * cost
    }

    updateIconTexts(key, finalCost, count)
}

function onInputChange() {
    const $this = this

    if ($(this).attr('data-cost')) {
        handleDataCost($this);
    }

    if ($this.tagName === 'SELECT') {
        earningsChanged = true;
    }

    updateTotalCost()

    if (earningsChanged) {
        $('.js-calculator-footer').show();
        showResult();
    }
}

function showResult() {
    const currentEarnings = $('.js-calc-monthly-earnings').val();
    $('.js-calc-default').hide();
    $('.js-calc-success').hide()
    $('.js-calc-fail').hide()

    const pageUrl = $('.js-page-url').text()
    const fbShare = 'https://www.facebook.com/sharer.php?u=' + pageUrl
    const twitterShare = 'https://twitter.com/intent/tweet?url=' + pageUrl

    const fbButton = $('.js-calculator-share-fb')
    const twitterButton = $('.js-calculator-share-twitter')
    let message;
    let suffix;

    if (parseInt(currentEarnings) >= state.total) {
        $('.js-calc-success').show()
        message = $('.js-success-share-message').text()
        suffix = '?result=success'
    } else {
        $('.js-calc-fail').show()
        message = $('.js-fail-share-message').text()
        suffix = '?result=fail'
    }

    fbButton.attr('href', `${fbShare}${suffix}`)
    twitterButton.attr('href', `${twitterShare}${suffix}&text=${message}`)

    const text = infoText.replace('#total#', state.total)
    $infoTextBlock.text(text)
}

function updateTotalCost() {
    const $elements = $root.find('.js-cost')

    const costs = [];
    $elements.each(function() {
        costs.push($(this).text())
    })

    state.total = Array.from(costs)
        .filter(item => item)
        .reduce((acc, curr) => {
            return acc + parseInt(curr)
        }, 0)
}

function getCheckedRadioCost(element) {
    return $(`input[name=${element.name}]:checked`).attr('data-cost');
}

function getElementValue(element) {
    if (element.type === 'radio') {
        return getCheckedRadioCost(element)
    }
    return $(element).val()
}


window.addEventListener('load', function() {
    if (! $inputs) {
        return
    }

    $inputs.each(function() {
        if ($(this).attr('data-cost')) {
            handleDataCost(this)
        }
        $(this).on('change', onInputChange)
    })
})
window.state = state
